import { Content } from "@bbnpm/bb-ui-framework";
import styled from "styled-components";

export const StyledContent = styled(Content)`
  height: 100%;
  position: fixed;
  width: 100vw;
  left: 0;
  z-index: -1;
  .text-wrapper {
    text-align: center;
    width: 100%;
    position: absolute;
    top: 40%;
    opacity: 50%;
    transform: translateY(-50%);
  }
`;
